/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /*
  if (document.body.classList.contains("template-index")) {
    if (window.innerWidth >= 1090) {
      window.addEventListener("scroll", function() {
        if (window.scrollY > 250) {
          document.querySelector('.header__desktop').classList.add('logo-visible');
          document.querySelector('.hero__logo_overlay').classList.add('hide-logo');
        } else {
          document.querySelector('.header__desktop').classList.remove('logo-visible');
          document.querySelector('.hero__logo_overlay').classList.remove('hide-logo');
        }
      });
    } else {
       window.addEventListener("scroll", function() {
        if (window.scrollY > 200) {
          document.querySelector('.hero__logo_overlay').classList.add('hide-logo');
          document.querySelector('.page-header').classList.add('logo-visible');
        } else {
          document.querySelector('.hero__logo_overlay').classList.remove('hide-logo');
          document.querySelector('.page-header').classList.remove('logo-visible');
        }
      });
    }
  }  
  */

  if (document.body.classList.contains("template-product")) {
    const open_link = document.querySelector('#open-ingredients');
    open_link.addEventListener("click", function(event) {
      document.querySelector('.drawer--ingredients').classList.add('is-open');
    });

    const close_link = document.querySelector('.drawer-ingredients__close');
    close_link.addEventListener("click", function() {
      document.querySelector('.drawer--ingredients').classList.remove('is-open');
    });

    const ingredients_drawer = document.querySelector('.ingredients-sidebar-wrapper'); 
    document.addEventListener('click', event => {
      const isClickInside = ingredients_drawer?.contains(event.target);
      const isClickLink = open_link?.contains(event.target);
      
      if (isClickLink) {
      } else {
        if(!isClickInside) {
          document.querySelector('.drawer--ingredients').classList.remove('is-open');
        }
      }
      
    });
  }


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
